module.exports = __webpack_public_path__ + "static/baker2-a23752c063157e49add47be64b1ca3e1.jpg";